import { render } from "./BonusDetail.vue?vue&type=template&id=7e94c004&scoped=true"
import script from "./BonusDetail.vue?vue&type=script&lang=js"
export * from "./BonusDetail.vue?vue&type=script&lang=js"

import "./BonusDetail.vue?vue&type=style&index=0&id=7e94c004&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e94c004"]])

export default __exports__